// extracted by mini-css-extract-plugin
export var filterIncDec = "_5c-0";
export var leftBorder = "_5c-1";
export var rightBorder = "_5c-2";
export var stringInput = "_5c-3";